import React, { useMemo } from 'react';
import ActivityLinkContext, { pageType, niePanZPMicroappBasename } from './base';
import goto from '@/common/goto';
import type { detailLink } from './base';

const linkConfig = {
  pageType: pageType.promotion,
  niePanZPMicroappBasename: niePanZPMicroappBasename.promotion,
  toActivityDetail: goto.promotionActivityDetail,
  toActivityDetailCommodityPool: goto.promotionActivityDetailCommodityPool,
  toActivityCreate: goto.promotionActivityCreate,
  toActivityDetailInfo: goto.promotionActivityDetailInfo,
  toActivityEdit: goto.promotionActivityEdit,
  toNiePanZPDetail: goto.promotionNiePanZPDetail,
  toNiePanStartZP: goto.promotionNiePanStartZP,
  toVenueDetail: goto.promotionVenueDetail,
  toVenue: goto.promotionVenue,
  toTiBaoVenueCreate: goto.promotionTiBaoVenueCreate,
  toTiBaoVenueEdit: goto.promotionTiBaoVenueEdit,
  toTiBaoQuaSetting: goto.promotionTiBaoQuaSetting,
  toTiBaoVenueSetting: goto.promotionTiBaoVenueSetting,
  toZCActivity: goto.promotionZCActivity,
  toCreateZCActivity: goto.promotionCreateZCActivity,
  toZCQualificationSetting: goto.promotionZCQualificationSetting,
  toZCResourceAllocation: goto.promotionZCResourceAllocation,
  toZCResourceDetail: goto.promotionZCResourceDetail,
  toMaterialPoolSet: goto.promotionMaterialPoolSet,
  toMaterialPoolEdit: goto.promotionMaterialPoolEdit,
  toMaterialManage: goto.promotionMaterialManage,
  toUploadMaterial: goto.promotionUploadMaterial,
  toManualUploadMaterial: goto.promotionManualUploadMaterial,
  toEditMaterial: goto.promotionEditMaterial,
  toNormalGoodlsPoolDetail: goto.promotionNormalGoodlsPoolDetail,
};

const Provider: React.FC<{
  value?: Partial<detailLink>;
}> = function ({ children, value = {} }) {
  const contextValue = useMemo(() => Object.assign({}, linkConfig, value), [value]);

  return <ActivityLinkContext.Provider value={contextValue}>{children}</ActivityLinkContext.Provider>;
};

export default Provider;
